import { render, staticRenderFns } from "./MultichannelChatbot.vue?vue&type=template&id=2ad0a75e"
import script from "./MultichannelChatbot.vue?vue&type=script&lang=js"
export * from "./MultichannelChatbot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports